import { TTableSortParams } from "types/general";

export enum TABLE_TABS_ENUM {
  ACTIVE_MARKET_AREAS = "ACTIVE_MARKET_AREAS",
  ARCHIVE_MARKET_AREAS = "ARCHIVE_MARKET_AREAS",
}

export type TActiveMarketAreasFilters = TTableSortParams;
export type TArchiveMarketAreasFilters = TTableSortParams;

export type TTableFiltersState = {
  [TABLE_TABS_ENUM.ACTIVE_MARKET_AREAS]: { filters: TActiveMarketAreasFilters };
  [TABLE_TABS_ENUM.ARCHIVE_MARKET_AREAS]: {
    filters: TArchiveMarketAreasFilters;
  };
};

export type TFiltersByTableName<T extends TABLE_TABS_ENUM> =
  TTableFiltersState[T]["filters"];
